import React from 'react';

const LoginActions = ({ redirectLinks, buttonText }) => {
  return (
    <div>
      <button type="submit" form="main-form">
        <b>{buttonText}</b>
      </button>
      {redirectLinks &&
        redirectLinks.map((link, index) => (
          <a
            key={index}
            href={link.route}
            style={{
              display: 'block',
              marginTop: '1rem',
              color: '#fff',
              textDecoration: 'underline',
            }}
          >
            {link.text}
          </a>
        ))}
    </div>
  );
};

export default LoginActions;
